export default __webpack_public_path__ + "static/media/logo_kadence.1106266f.png";